/**
 * Created by Administrator on 2017/10/27.
 */
import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {HttpService} from "../service/http-service";
import {FileUpload} from "../service/file-upload";
import {API} from "../config/api-config";
declare var alertify:any;
@Component({
  templateUrl:'./editBanner.html'
})

export class EditBanner implements OnInit{
  constructor(
    private router:Router,
    private route:ActivatedRoute,
    private HttpService:HttpService,
    private fileupload:FileUpload,
    private location:Location
  ){}


  private data:any={
      'id':'',
      'iconEn':'',
      'iconTc':'',
      'urlEn':'',
      'urlTc':'',
      'categoryId':"",
      'newsId':"",
      'regionType':"",
      "aboutCategoryId":"",
      "aboutId":"",

  }

  private id:number = 0;
  private imagePath:string='';
  private isCreate:boolean=false;
  private language='en';
  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id=params['id'];
    });
    this.getNewsCategory();
    this.getAboutCategory();
    this.getRegionType();
    this.getNewsTitle();
    this.getAboutTitleData();
    if(this.id!=0){
      this.getPath();
      this.getData();
    }else {
      this.isCreate=true;
    }
  }
  private showByLanguage(type:string){
    this.language=type;
  }

  private getData():void{
    this.HttpService.getData(API.banner+'/'+this.id).then(res=>{
      this.data = res.data;
    })
  }

  // 获取路径
  private getPath():void{
    this.HttpService.getData(API.resourcePath)
      .then(res=>{
        this.imagePath=res.data;
        console.log(res.data)
      })
  }
//new id
  private newsData:any=[]
  private getNewsCategory():void{
    this.HttpService.getData(API.activeNewsCategory).then(res=>{
      this.newsData = res.data;
    })
  }
  //news title
  private newsTitleData:any=[]
  private getNewsTitle():void{
    this.HttpService.getData(API.news).then(res=>{
      this.newsTitleData = res.data;
    })
  }

  //about id
  private categoryData:any=[]
  private getAboutCategory():void{
    this.HttpService.getData(API.activeAboutUsCategory).then(res=>{
      this.categoryData = res.data;
    })
  }

  public changeRegionType(){
    this.data.categoryId = '';
    this.data.newsId = '';
    this.data.aboutCategoryId = '';
    this.data.aboutId = '';
  }

  //about title
  private aboutTitleData:any=[]
  private getAboutTitleData():void{
    this.HttpService.getData(API.aboutUs).then(res=>{
      this.aboutTitleData = res.data;
    })
  }

  //regionType
  private regionTypeData:any=[]
  private getRegionType():void{
    this.HttpService.getData(API.banner_regionType).then(res=>{
      this.regionTypeData = res.data;
    })
  }

  private submit():void{
    this.HttpService.postData(API.banner,{
      'id':this.id,
      'iconEn':this.data.iconEn,
      'iconTc':this.data.iconTc,
      'urlEn':this.data.urlEn,
      'urlTc':this.data.urlTc,
      'categoryId':this.data.categoryId,
      'newsId':this.data.newsId,
      'regionType':this.data.regionType,
      "aboutCategoryId":this.data.aboutCategoryId,
      "aboutId":this.data.aboutId,
    }).then(res=>{
      let data=res;
      if(data.status.code==0 || data.status.code=='0'){
        this.location.back();
        alertify.success(data.status.message);
      }else{
        alertify.error(data.status.message);
      }
    });
   }

  private showIconEn:boolean = false;
  private showIconTc:boolean = false;
  private tempPath:string=API.getTemp;
  private upload(name:string){
    let self=this;
    this.fileupload.upload(function (res) {
      let temRes=JSON.parse(res);
      if(temRes.status.code==0){
        switch (name){
          case 'iconEn':self.showIconEn=true;break;
          case 'iconTc':self.showIconTc=true;break;
        }
        self.data[name]=temRes.data.fileName;
      }
    });
  }

}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/banner/BannerEdit.componen.ts